
import { styleInstaller } from "./chrome";

export interface SocialActions {
  onToggle?: () => void;
}

const STYLE_ID = "social-opener-style";

const STYLE = `
.social-opener {
  position: fixed;
  left: max(14px, env(safe-area-inset-left));
  bottom: max(14px, env(safe-area-inset-bottom));
  z-index: 12;
  min-width: 92px;
  padding: 7px 11px;
  border-radius: 9px;
  border: 1px solid rgba(255, 236, 170, 0.24);
  background: rgba(12, 14, 18, 0.82);
  color: #d8dee6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.32);
  backdrop-filter: blur(7px);
  pointer-events: auto;
  cursor: pointer;
  font: 11px/1.2 system-ui, sans-serif;
  letter-spacing: 0.04em;
}
.social-opener:hover,
.social-opener[aria-expanded="true"] {
  border-color: rgba(143, 208, 240, 0.56);
  background: rgba(38, 57, 70, 0.9);
}
/* The original has exactly one Friends control -- MessengerButton, built
   into the task bar (locale/en/ui/taskbar.py:336-348, x: SCREEN_WIDTH - 76).
   The task bar's own button (ui/taskbar.ts's .legacy-taskbar-messenger)
   already reaches every screen this wide, so showing this floating pill too
   would be the two-openers-for-one-window clutter the source never had.
   Below the task bar's own "hide the right-hand buttons" breakpoint
   (taskbar.ts's @media (max-width: 620px), which drops
   .legacy-taskbar-right for space) this is the only opener left, so it
   stays for that width. */
@media (min-width: 621px) {
  .social-opener { display: none; }
}
`;

const installStyle = styleInstaller(STYLE_ID, STYLE);

export function isSocialShortcut(event: Pick<KeyboardEvent, "code" | "altKey" | "metaKey" | "ctrlKey">): boolean {
  return event.code === "KeyM" && event.altKey && !event.metaKey && !event.ctrlKey;
}

export class SocialOpener {
  private readonly button: HTMLButtonElement;

  constructor(container: HTMLElement, actions: SocialActions = {}) {
    const doc = container.ownerDocument;
    installStyle(doc);
    this.button = doc.createElement("button");
    this.button.type = "button";
    this.button.className = "social-opener";
    // HELP_MESSENGER_WINDOW is "Open Friends List: Alt + M"
    // (`locale_interface.txt:155`); the messenger window this opens is titled
    // "Friends" (MESSENGER_TITLE, `:198`), never "Social".
    this.button.textContent = "Friends · Alt+M";
    this.button.setAttribute("aria-controls", "friends");
    this.button.setAttribute("aria-expanded", "false");
    this.button.addEventListener("click", () => actions.onToggle?.());
    container.append(this.button);
  }

  setExpanded(expanded: boolean): void {
    this.button.setAttribute("aria-expanded", String(expanded));
  }
}
